import { useCallback, useEffect } from 'react'
import { createGlobalState } from 'react-use'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, AppState } from 'state'
import gotchiBgmSrc from 'assets/vvsgotchi/bgm.mp3'
import { muteBgm, muteSe, unmuteBgm, unmuteSe } from '..'

const useBgmSrc = createGlobalState<string | null>(null)
const useBgmTmpPause = createGlobalState<boolean>(false)

export function useVvsGotchiAudioModeManager() {
  const dispatch = useDispatch<AppDispatch>()
  const [bgmPlay, sePlay] = useSelector<AppState, [AppState['vvsgotchi']['bgmPlay'], AppState['vvsgotchi']['sePlay']]>(
    (state) => [state.vvsgotchi.bgmPlay, state.vvsgotchi.sePlay],
  )

  const toggleSetBgmMode = useCallback(() => {
    if (bgmPlay) {
      dispatch(muteBgm())
    } else {
      dispatch(unmuteBgm())
    }
  }, [bgmPlay, dispatch])
  const toggleSetSeMode = useCallback(() => {
    if (sePlay) {
      dispatch(muteSe())
    } else {
      dispatch(unmuteSe())
    }
  }, [sePlay, dispatch])

  return {
    bgmPlay,
    sePlay,
    toggleSetBgmMode,
    toggleSetSeMode,
  }
}

export const MUTED = 'MUTED'
export const GOTCHI_DEFAULT_BGM = gotchiBgmSrc
export function useBgm(src: string | typeof MUTED | null) {
  const [_bgmSrc, setBgmSrc] = useBgmSrc()
  const [_bgmTmpPause, setBgmTmpPause] = useBgmTmpPause()

  useEffect(() => {
    if (src === MUTED) {
      setBgmTmpPause(true)
      return () => setBgmTmpPause(false)
    }

    setBgmSrc(src)
    return () => setBgmSrc(null)
  }, [src, setBgmSrc, setBgmTmpPause])
}

export function useBgmPlayer() {
  const [bgmSrc] = useBgmSrc()
  const [bgmTmpPause] = useBgmTmpPause()

  return {
    currentBgmSrc: bgmSrc || GOTCHI_DEFAULT_BGM,
    bgmTmpPause,
  }
}
